<template>
  <div>
    <h5 class="p-t-10" v-if="log.note !== null">
      {{ $t("Note from") }} {{ log.User.firstname }}
    </h5>
    <h5 class="p-t-10" v-else>
      {{ $t(log.status) }}
    </h5>
    <p class="text-muted">{{ log.User.firstname }} {{ log.User.lastname }}</p>
    <div v-if="log.note !== null">
      <p v-show="!expanded">
        <vue-markdown>{{ log.note | cutText(120) }}</vue-markdown> <a v-if="!expanded && log.note !== null && log.note.length > 120"><i class="ti-plus"></i> {{ $t("read more") }}</a>
        <a v-if="expanded && log.note !== null && log.note.length > 120"><i class="ti-plus"></i> {{ $t("read less") }}</a>
      </p>
      <p v-show="expanded">
        <vue-markdown>{{ log.note }}</vue-markdown> <a v-if="!expanded && log.note !== null && log.note.length > 120"><i class="ti-plus"></i> {{ $t("read more") }}</a>
        <a v-if="expanded && log.note !== null && log.note.length > 120"><i class="ti-plus"></i> {{ $t("read less") }}</a>
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ActionNote",
    props: ['log'],
    data: function(){
      return{
        expanded: false
      }
    },
    created(){
      let vm = this;
      this.$parent.$on("toggleLog", function (data) {
        if(data === vm.log.uid){
          vm.expanded = !vm.expanded;
        }
      });
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ActionNote.vue